export default __webpack_public_path__ + "static/land-registry-6bbf1d516467efb7738d15d9b3d725ac.png";